import { createFlatMessageLookup } from './flatMessages';
export const getChatMessage = createFlatMessageLookup({
  "zh_TW": {
    "travel.chat.back": "回到訊息",
    "travel.chat.loading": "載入對話…",
    "travel.chat.notFound": "對話不存在",
    "travel.chat.unavailable": "這則對話可能已無法檢視。",
    "travel.chat.loadFailed": "無法載入對話",
    "travel.chat.retry": "再試一次",
    "travel.chat.readonly": "聊天室目前為唯讀。",
    "travel.chat.degraded": "連線不穩，仍可透過送出更新對話。",
    "travel.chat.empty": "開始這段對話吧。",
    "travel.chat.older": "載入較早訊息",
    "travel.chat.busy": "載入中…",
    "travel.chat.message": "訊息",
    "travel.chat.placeholder": "輸入訊息",
    "travel.chat.send": "送出",
    "travel.chat.sending": "送出中…",
    "travel.chat.image": "選擇圖片",
    "travel.chat.video": "選擇影片",
    "travel.chat.file": "選擇檔案",
    "travel.chat.preview": "預覽",
    "travel.chat.cancel": "取消",
    "travel.chat.uploading": "上傳中…",
    "travel.chat.sendImage": "送出圖片",
    "travel.chat.picker": "Emoji、貼圖與 GIF",
    "travel.chat.emoji": "Emoji",
    "travel.chat.stickers": "貼圖",
    "travel.chat.gifs": "GIF",
    "travel.chat.noEmotes": "沒有可用貼圖／GIF",
    "travel.chat.search": "搜尋貼圖或 GIF",
    "travel.chat.choose": "選擇 {name}",
    "travel.chat.failed": "訊息無法送出，請稍後再試。",
    "travel.chat.tooLarge": "檔案過大，請選擇較小的檔案。",
    "travel.chat.unsupported": "不支援此檔案格式。",
    "travel.chat.imageUnsupported": "僅支援 JPG、PNG、GIF。",
    "travel.chat.addReaction": "加入反應",
    "travel.chat.pickReaction": "選擇反應",
    "travel.chat.reactionCount": "{emoji}，{count} 個回應",
    "travel.chat.react": "對這則訊息加入 {emoji}，{count} 個回應",
    "travel.chat.unreact": "移除 {emoji} 回應，{count} 個回應",
    "travel.chat.pickEmoji": "對這則訊息加入 {emoji}",
    "travel.chat.avatar": "預設會員頭像",
    "travel.chat.member": "會員",
    "travel.chat.group": "群組對話",
    "travel.chat.direct": "私人對話",
    "travel.chat.edited": "已編輯",
    "travel.chat.edit": "編輯",
    "travel.chat.editMessage": "編輯訊息",
    "travel.chat.revoke": "撤回",
    "travel.chat.revokeMessage": "撤回訊息",
    "travel.chat.confirmRevoke": "確認撤回",
    "travel.chat.revokePrompt": "確定要撤回這則訊息嗎？撤回後聊天室仍會保留撤回紀錄。",
    "travel.chat.revoking": "撤回中…",
    "travel.chat.save": "儲存",
    "travel.chat.saving": "儲存中…",
    "travel.chat.revoked": "此訊息已撤回",
    "travel.chat.mediaFailed": "媒體無法顯示",
    "travel.chat.download": "下載檔案",
    "travel.chat.authExpired": "登入已過期，請重新登入後再試。",
    "travel.chat.chatDisabled": "目前暫時無法建立新的對話，請稍後再試。",
    "travel.chat.more": "訊息更多操作",
    "travel.chat.imageButton": "圖片",
    "travel.chat.videoButton": "影片",
    "travel.chat.fileButton": "檔案",
    "travel.chat.reactionReadonly": "聊天室目前為唯讀，無法回應訊息。",
    "travel.chat.editDenied": "目前無法編輯這則訊息。",
    "travel.chat.revokeDenied": "目前無法撤回這則訊息。",
    "travel.chat.fallbackImage": "[圖片]",
    "travel.chat.fallbackMessage": "[訊息]",
    "travel.chat.unsupportedCard": "此卡片目前無法顯示",
    "travel.chat.inboxHint": "與旅人的私訊會顯示在這裡。",
    "travel.chat.inboxEmpty": "還沒有訊息",
    "travel.chat.inboxEmptyHint": "從創作者頁或貼文傳訊息後，對話會出現在這裡。",
    "travel.chat.noMessages": "尚無訊息",
    "travel.chat.muted": "已靜音",
    "travel.chat.unreadCount": "{name}，{count} 則未讀"
  },
  "zh_CN": {
    "travel.chat.back": "返回消息",
    "travel.chat.loading": "加载对话…",
    "travel.chat.notFound": "对话不存在",
    "travel.chat.unavailable": "此对话可能已无法查看。",
    "travel.chat.loadFailed": "无法加载对话",
    "travel.chat.retry": "重试",
    "travel.chat.readonly": "聊天室目前为只读。",
    "travel.chat.degraded": "连接不稳定，仍可通过发送更新对话。",
    "travel.chat.empty": "开始这段对话吧。",
    "travel.chat.older": "加载较早消息",
    "travel.chat.busy": "加载中…",
    "travel.chat.message": "消息",
    "travel.chat.placeholder": "输入消息",
    "travel.chat.send": "发送",
    "travel.chat.sending": "发送中…",
    "travel.chat.image": "选择图片",
    "travel.chat.video": "选择视频",
    "travel.chat.file": "选择文件",
    "travel.chat.preview": "预览",
    "travel.chat.cancel": "取消",
    "travel.chat.uploading": "上传中…",
    "travel.chat.sendImage": "发送图片",
    "travel.chat.picker": "Emoji、贴图与 GIF",
    "travel.chat.emoji": "Emoji",
    "travel.chat.stickers": "贴图",
    "travel.chat.gifs": "GIF",
    "travel.chat.noEmotes": "没有可用贴图／GIF",
    "travel.chat.search": "搜索贴图或 GIF",
    "travel.chat.choose": "选择 {name}",
    "travel.chat.failed": "消息无法发送，请稍后重试。",
    "travel.chat.tooLarge": "文件过大，请选择较小的文件。",
    "travel.chat.unsupported": "不支持此文件格式。",
    "travel.chat.imageUnsupported": "仅支持 JPG、PNG、GIF。",
    "travel.chat.addReaction": "加入回应",
    "travel.chat.pickReaction": "选择回应",
    "travel.chat.reactionCount": "{emoji}，{count} 个回应",
    "travel.chat.react": "对此消息加入 {emoji}，{count} 个回应",
    "travel.chat.unreact": "移除 {emoji} 回应，{count} 个回应",
    "travel.chat.pickEmoji": "对此消息加入 {emoji}",
    "travel.chat.avatar": "默认会员头像",
    "travel.chat.member": "会员",
    "travel.chat.group": "群组对话",
    "travel.chat.direct": "私人对话",
    "travel.chat.edited": "已编辑",
    "travel.chat.edit": "编辑",
    "travel.chat.editMessage": "编辑消息",
    "travel.chat.revoke": "撤回",
    "travel.chat.revokeMessage": "撤回消息",
    "travel.chat.confirmRevoke": "确认撤回",
    "travel.chat.revokePrompt": "确定要撤回此消息吗？聊天室仍会保留撤回记录。",
    "travel.chat.revoking": "撤回中…",
    "travel.chat.save": "保存",
    "travel.chat.saving": "保存中…",
    "travel.chat.revoked": "此消息已撤回",
    "travel.chat.mediaFailed": "媒体无法显示",
    "travel.chat.download": "下载文件",
    "travel.chat.authExpired": "登录已过期，请重新登录。",
    "travel.chat.chatDisabled": "暂时无法建立新对话，请稍后重试。",
    "travel.chat.more": "消息更多操作",
    "travel.chat.imageButton": "图片",
    "travel.chat.videoButton": "视频",
    "travel.chat.fileButton": "文件",
    "travel.chat.reactionReadonly": "聊天室目前为只读，无法回应消息。",
    "travel.chat.editDenied": "目前无法编辑此消息。",
    "travel.chat.revokeDenied": "目前无法撤回此消息。",
    "travel.chat.fallbackImage": "[图片]",
    "travel.chat.fallbackMessage": "[消息]",
    "travel.chat.unsupportedCard": "此卡片目前无法显示",
    "travel.chat.inboxHint": "与旅人的私信会显示在这里。",
    "travel.chat.inboxEmpty": "还没有消息",
    "travel.chat.inboxEmptyHint": "从创作者页或帖子发送消息后，对话会显示在这里。",
    "travel.chat.noMessages": "暂无消息",
    "travel.chat.muted": "已静音",
    "travel.chat.unreadCount": "{name}，{count} 条未读"
  },
  "en_US": {
    "travel.chat.back": "Back to messages",
    "travel.chat.loading": "Loading conversation…",
    "travel.chat.notFound": "Conversation not found",
    "travel.chat.unavailable": "This conversation is no longer available.",
    "travel.chat.loadFailed": "Could not load conversation",
    "travel.chat.retry": "Retry",
    "travel.chat.readonly": "This conversation is read-only.",
    "travel.chat.degraded": "Reconnecting. You can still send messages.",
    "travel.chat.empty": "Start the conversation.",
    "travel.chat.older": "Load earlier messages",
    "travel.chat.busy": "Loading…",
    "travel.chat.message": "Message",
    "travel.chat.placeholder": "Message…",
    "travel.chat.send": "Send",
    "travel.chat.sending": "Sending…",
    "travel.chat.image": "Choose image",
    "travel.chat.video": "Choose video",
    "travel.chat.file": "Choose file",
    "travel.chat.preview": "Preview",
    "travel.chat.cancel": "Cancel",
    "travel.chat.uploading": "Uploading…",
    "travel.chat.sendImage": "Send image",
    "travel.chat.picker": "Emoji, stickers and GIFs",
    "travel.chat.emoji": "Emoji",
    "travel.chat.stickers": "Stickers",
    "travel.chat.gifs": "GIF",
    "travel.chat.noEmotes": "No stickers or GIFs available.",
    "travel.chat.search": "Search stickers or GIFs",
    "travel.chat.choose": "Choose {name}",
    "travel.chat.failed": "Could not send. Please retry.",
    "travel.chat.tooLarge": "This file is too large. Choose a smaller file.",
    "travel.chat.unsupported": "This file format is not supported.",
    "travel.chat.imageUnsupported": "Only JPG, PNG and GIF are supported.",
    "travel.chat.addReaction": "Add reaction",
    "travel.chat.pickReaction": "Choose reaction",
    "travel.chat.reactionCount": "{emoji}, {count} reactions",
    "travel.chat.react": "React {emoji}, {count} reactions",
    "travel.chat.unreact": "Remove {emoji}, {count} reactions",
    "travel.chat.pickEmoji": "React with {emoji}",
    "travel.chat.avatar": "Default member avatar",
    "travel.chat.member": "Member",
    "travel.chat.group": "Group conversation",
    "travel.chat.direct": "Direct conversation",
    "travel.chat.edited": "Edited",
    "travel.chat.edit": "Edit",
    "travel.chat.editMessage": "Edit message",
    "travel.chat.revoke": "Unsend",
    "travel.chat.revokeMessage": "Unsend message",
    "travel.chat.confirmRevoke": "Confirm unsend",
    "travel.chat.revokePrompt": "Unsend this message? An unsent-message notice will remain.",
    "travel.chat.revoking": "Unsending…",
    "travel.chat.save": "Save",
    "travel.chat.saving": "Saving…",
    "travel.chat.revoked": "This message was unsent.",
    "travel.chat.mediaFailed": "Could not display media.",
    "travel.chat.download": "Download file",
    "travel.chat.authExpired": "Your session expired. Please sign in again.",
    "travel.chat.chatDisabled": "Chat is temporarily unavailable.",
    "travel.chat.more": "More message actions",
    "travel.chat.imageButton": "Image",
    "travel.chat.videoButton": "Video",
    "travel.chat.fileButton": "File",
    "travel.chat.reactionReadonly": "This conversation is read-only. Reactions are unavailable.",
    "travel.chat.editDenied": "You cannot edit this message.",
    "travel.chat.revokeDenied": "You cannot unsend this message.",
    "travel.chat.fallbackImage": "[Image]",
    "travel.chat.fallbackMessage": "[Message]",
    "travel.chat.unsupportedCard": "This card cannot be displayed.",
    "travel.chat.inboxHint": "Your conversations with travelers appear here.",
    "travel.chat.inboxEmpty": "No messages yet",
    "travel.chat.inboxEmptyHint": "Start a conversation from a profile or post.",
    "travel.chat.noMessages": "No messages yet",
    "travel.chat.muted": "Muted",
    "travel.chat.unreadCount": "{name}, {count} unread"
  }
});
